import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./Lab.css";
import "./Orders/Orders.css";
import { selectDoctors, selectShowDoctorOrders, setDoctors, setShowDoctorOrders } from "./labSlice";
import { deleteDoctor, getDoctors, newDoctor, uploadPhoto, saveDoctor } from "./labApi";
import doc_logo from '../../../static/img/doc.png';
import { setDoctorCompany, setDoctorName, setOrders } from "./Orders/orderSlice";
import { setDoctorId } from "../Login/loginSlice";
import Orders from "./Orders/Orders";
import NewDoctorForm from "./NewDoctorForm";

const DoctorList = ({ userId }) => {
    const dispatch = useDispatch();
    const doctors = useSelector(selectDoctors);
    const showDoctorOrders = useSelector(selectShowDoctorOrders)
    const [stringFind, setStringFind] = useState("");
    const [findArray, setFindArray] = useState([]);
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [showNewDoctor, setShowNewDoctor] = useState(false);
    const [editDoctorData, setEditDoctorData] = useState(null);
    const [openMenuId, setOpenMenuId] = useState(null);
    const [showDelDoctorId, setShowDelDoctorId] = useState(null);

    useEffect(() => {
        getDoctors({ user_id: userId }, (res) => {
            dispatch(setDoctors(res.data || []));
        });
    }, [userId, dispatch]);

    const filteredDoctors = doctors;

    const handleDelete = (doctor_id) => {
        deleteDoctor({ doctor_id, user_id: userId }, (data) => {
            // console.log('del doc', data);
            getDoctors({ user_id: userId }, (res) => {
                const list = res.data || [];
                dispatch(setDoctors(list));
                setFindArray(new Array(list.length).fill(1));
                // если форма редактирования открыта, закрываем её
                setShowNewDoctor(false);
            });
        });
    };

    const handleFind = (text) => {
        const new_find_array = findArray.slice();
        for (let i = 0; i < doctors.length; i++) {
            const fullName = ((doctors[i]?.name || "") + (doctors[i]?.surname || "")).toLowerCase();
            const company = (doctors[i]?.company || "").toLowerCase();
            const q = text.toLowerCase();
            if (fullName.indexOf(q) !== -1 || company.indexOf(q) !== -1) new_find_array[i] = 1;
            else new_find_array[i] = 0;
        }
        setFindArray(new_find_array);
        setStringFind(text);
    };

    useEffect(() => {
        if (doctors && doctors.length) {
            setFindArray(new Array(doctors.length).fill(1));
        } else {
            setFindArray([]);
        }
    }, [doctors]);

    const handleClickDoctor = (doc) => {
        console.log('handleClickDoctor', doc)
        setSelectedDoctor(doc);
        dispatch(setOrders([]));
        dispatch(setDoctorId(doc.doctor_id));
        dispatch(setDoctorName(doc.name + " " + doc.surname));
        dispatch(setDoctorCompany(doc.company));
        dispatch(setShowDoctorOrders(true));
    };

    const handleClickNewDoctor = () => {
        setEditDoctorData(null);
        setShowNewDoctor(true);
    };

    const handleCloseNewDoctor = () => {
        setShowNewDoctor(false);
    };

    const handleUpdateDoctor = (doctor_id, payload) => {
        console.log('update doctor', doctor_id, payload);
        const savePars = {
            ...payload,
            user_id: doctor_id,
            doctor_id
        };

        saveDoctor(savePars, (data) => {
            if (payload.photo) {
                uploadPhoto({ photo: payload.photo, user_id: doctor_id }, (uploadData) => {
                    getDoctors({ user_id: userId }, (res) => {
                        dispatch(setDoctors(res.data || []));
                    });
                    handleCloseNewDoctor();
                });
            } else {
                getDoctors({ user_id: userId }, (res) => {
                    dispatch(setDoctors(res.data || []));
                });
                handleCloseNewDoctor();
            }
        });
    };

    const handleCreateDoctor = (doctorData) => {
        newDoctor({
            email: doctorData.email,
            password: doctorData.password,
            name: doctorData.name,
            surname: doctorData.surname,
            country: doctorData.country,
            region: doctorData.region,
            company: doctorData.company,
            inn: doctorData.inn || '',
            kpp: doctorData.kpp || '',
            user_id: userId
        }, (data) => {
            const u_id = data.user_id;
            if (!data.res) {
                alert('Ошибка регистрации: ' + data.reason);
                return;
            }
            
            // Если есть фото, загружаем его
            if (doctorData.photo) {
                uploadPhoto({ photo: doctorData.photo, user_id: u_id }, (uploadData) => {
                    if (uploadData.res) {
                        // Обновляем список докторов после успешного создания
                        getDoctors({ user_id: userId }, (res) => {
                            dispatch(setDoctors(res.data || []));
                        });
                        handleCloseNewDoctor();
                    } else {
                        alert('Ошибка загрузки фото');
                    }
                });
            } else {
                // Обновляем список докторов после успешного создания
                getDoctors({ user_id: userId }, (res) => {
                    dispatch(setDoctors(res.data || []));
                });
                handleCloseNewDoctor();
            }
        });
    };


    if (showDoctorOrders && selectedDoctor) {
        return <Orders doctor_company={selectedDoctor.company} doctorId={selectedDoctor.doctor_id} />;
    }

    return (
        <div className="cntr_doctor_list">
            <div className="doctor-list-header">
                <input
                    type="text"
                    placeholder="Поиск"
                    value={stringFind}
                    onChange={e => handleFind(e.target.value)}
                    className="input-find"
                />
                <div className="orders-plus-icon" onClick={handleClickNewDoctor}>
                    +
                </div>
            </div>
            <div>
                {filteredDoctors.map((doc, index) => (
                    <div key={doc.doctor_id} className="doctor-card" style={{ display: findArray[index] === 1 ? 'flex' : 'none' }} onClick={() => handleClickDoctor(doc)}>
                        <img
                            src={
                                doc.photo_path
                                    ? `${process.env.REACT_APP_API_URL}static/uploads/${doc.photo_path}`
                                    : doc_logo
                            }
                            alt={doc.name}
                            className="doctor-photo"
                        />


                        <div className="doctor-info-lab">
                            <div className="doctor-name">{doc.surname} {doc.name} ({doc.company})</div>
                            <div className="doctor-stats">
                                <span>Заказы: {doc.quantity_orders || 0}</span>
                                <span style={{ color: doc.debt ? "red" : "green" }}>
                                    Долг: {doc.debt || 0} руб
                                </span>
                            </div>
                        </div>
                        <div className="doctor-item-dots" onClick={(e) => e.stopPropagation()}>
                            <div className="dots" onClick={(e) => { e.stopPropagation(); setOpenMenuId(openMenuId === doc.doctor_id ? null : doc.doctor_id); }}>
                                ⋮
                            </div>
                            {openMenuId === doc.doctor_id && (
                                <div className="order-menu-dropdown" onClick={(e) => e.stopPropagation()}>
                                    <div className="menu-item" onClick={(e) => { e.stopPropagation(); setEditDoctorData(doc); setShowNewDoctor(true); setOpenMenuId(null); }}>
                                        Редактировать
                                    </div>
                                    <div className="menu-item" onClick={(e) => { e.stopPropagation(); setShowDelDoctorId(doc.doctor_id); setOpenMenuId(null); }}>
                                        Удалить
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
            
            {showNewDoctor && (
                <NewDoctorForm
                    handleClose={handleCloseNewDoctor}
                    handleCreateDoctor={handleCreateDoctor}
                    initialData={editDoctorData}
                    mode={editDoctorData ? 'edit' : 'create'}
                    handleUpdateDoctor={handleUpdateDoctor}
                    handleDeleteDoctor={handleDelete}
                />
            )}

            {showDelDoctorId && (
                <div className="modal-overlay" onClick={() => setShowDelDoctorId(null)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <h4>Удалить доктора?</h4>
                        <div style={{ display: 'flex', gap: 12, marginTop: 12 }}>
                            <button className="modal-btn" onClick={() => setShowDelDoctorId(null)}>Нет</button>
                            <button className="modal-btn" onClick={() => { handleDelete(showDelDoctorId); setShowDelDoctorId(null); }}>Да</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DoctorList;
